module.exports = __webpack_public_path__ + "static/media/ticket-alt.3c2c0bb3.svg";